// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"75":"1c55ed177f143586","888":"c81f2d2bc4e93846"}[chunkId] + ".css";
};